import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaestroNgModule } from 'maestro-ng';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { SharedModule } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { KeyFilterModule } from 'primeng/keyfilter';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PasswordModule } from 'primeng/password';
import { PickListModule } from 'primeng/picklist';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SpinnerModule } from 'primeng/spinner';
import { BadgeModule } from 'primeng/badge';
import { SplitButtonModule } from 'primeng/splitbutton';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import {TimelineModule} from 'primeng/timeline';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { DominioPipe } from './pipe/dominio.pipe';
import { SafeHtmlPipe } from './pipe/safe-html.pipe';
import { UsuarioRoutingModule } from './usuario/usuario.routing';
import { LocalePtBr } from './util/locale-pt-br.model';
import { MomentModule } from 'ngx-moment';
import {BotaoVoltarDirective} from './directives/botao-voltar.directive';
import { EditorModule } from 'primeng/editor';



@NgModule({
  declarations: [
    SafeHtmlPipe,
    DominioPipe,
    BotaoVoltarDirective,
  ],
  exports: [
    CommonModule,
    FormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    UsuarioRoutingModule,
    MaestroNgModule,

    // Primeng
    AutoCompleteModule,
    BlockUIModule,
    ButtonModule,
    CheckboxModule,
    ConfirmDialogModule,
    ColorPickerModule,
    DialogModule,
    DropdownModule,
    InputTextModule,
    InputTextareaModule,
    InputSwitchModule,
    OverlayPanelModule,
    RadioButtonModule,
    SelectButtonModule,
    BadgeModule,
    SharedModule,
    SpinnerModule,
    TabViewModule,
    PanelModule,
    PasswordModule,
    FileUploadModule,
    TableModule,
    SafeHtmlPipe,
    PaginatorModule,
    InputMaskModule,
    KeyFilterModule,
    FieldsetModule,
    CalendarModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    DynamicDialogModule,
    TooltipModule,
    TimelineModule,
    ScrollPanelModule,
    CurrencyMaskModule,
    SplitButtonModule,
    MultiSelectModule,
    ChipsModule,
    PickListModule,
    CardModule,
    StepsModule,
    InputNumberModule,
    VirtualScrollerModule,
    DominioPipe,
    MomentModule,
    BotaoVoltarDirective,
    EditorModule,
  ],
  providers: [
    LocalePtBr,
  ]
})
export class AppSharedModule {}

